import { useEffect, useMemo, useState } from "react"
import { ErrorCard, LoadingCard, MainContainer } from "../../components"
import { Button, Progress } from "@heroui/react"
import { usePost } from "../../api/reactQueryCustomHooks"
import { apiRoute, ENUM_PAGEACTION_TYPE, GetLoginCredentialDb, linksUrl } from "../../constants/enum"
import { useDispatch, useSelector } from "react-redux"
import { toast } from "react-toastify"
import NextUITable, { COLUMN_ALIGN_TYPE, FOOTER_TYPE, ROW_ACTION_BTN_TYPE } from "../../components/NextUITable"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faDownload, faEdit, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons"
import { useNavigate } from "react-router-dom"
import { resetAcInfo, resetDetail, setAcInfo, setAccountDetail, setNewEntryMode } from "../../state/accountSlice"
import { calculateTotal } from "../../Utility/utility"
import ConfirmBox from "../../components/ConfirmBox"
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const AccountMaster = () => {
    let { compCode, compName, isMultipleCompany, yearId } = useSelector((state) => state.company)
    let { token, user } = useSelector((state) => state.auth)
    let navigate = useNavigate();
    let dispatch = useDispatch();
    let [itemToDelete, setItemToDelete] = useState("")
    const [itemToEdit, setItemToEdit] = useState("")
    const [pageActionType, setPageActionType] = useState("")

    // let [data, setData] = useState([])

    useEffect(() => {
        if (isMultipleCompany)
            navigate(linksUrl.dashboard.tradingDashboard)
    }, [])

    const INITIAL_VISIBLE_COLUMNS = [
        "actions",
        "AC_ID",
        "AC_DESC",
        "ACTYPENAME",
        "GRP_DESC",
        "OPBAL",

    ]
    const exportColumns = [
        {
            name: "ACCOUNT ID",
            uid: "AC_ID",
        },
        {
            name: "Description",
            uid: "AC_DESC",
        },
        {
            name: "ACCOUNT Type",
            uid: "ACTYPENAME",
        },
        {
            name: "UNDER GROUP",
            uid: "GRP_DESC",
        },
        {
            name: "OPENING BAL",
            uid: "OPBAL",

        },
    ]
    const onSuccessDelete = (data) => {
        if (data && data.length > 0) {
            if (data[0].ref == 1) {
                toast.error("Account can't be delete as it locked", {
                    position: "top-center",
                    "className": "toast-error",
                })
            }
            else {
                setItemToDelete("")
                filterAccount({
                    data: {
                        comp_code: compCode.join(","),
                        ac_id: ''
                    }
                })
                toast.success("Account Deleted",
                    {
                        position: "top-center",
                        "className": "toast-error",
                    })

            }


        }
    }

    const { mutate: FndeleteAccount } = usePost(
        {
            url: apiRoute.account.deleteAccount,
            query: "delete-note",
            onSuccessTasks: onSuccessDelete
        }
    )

    const { isPending, isError, data = [], mutate: filterAccount } = usePost({
        url: apiRoute.account.fetch,
        queryKey: "fetchAccountMaster"

    })

    const funLoadData = () => {
        filterAccount({
            data: {
                comp_code: compCode.join(","),
                ac_id: ''
            }
        })
    }

    // const handleDataChange = ({ data, isFilter }) => {
    //     if (isFilter)
    //         setData(data)
    //     else
    //         setData(AccountData)
    // }

    useEffect(() => {
        funLoadData();
    }, [])

    // useEffect(() => {
    //     setData(AccountData)
    // }, [AccountData])


    let totalOpeningBal = useMemo(
        () =>
            calculateTotal({
                data: data,
                columnName: "OPBAL",
            }),
        [data]
    )

    let downloadDataFooter = {
        AC_ID: "",
        AC_DESC: "",
        ACTYPENAME: "",
        GRP_DESC: "",
        OPBAL: " Total:" + totalOpeningBal

    }
    const exportAcccount = () => {
        const doc = new jsPDF();

        const companyName = compName.join(",");
        const reportName = "Account Master Listing";
        const pageWidth = doc.internal.pageSize.getWidth();

        // Table columns
        const columns = [
            // { header: "ACC ID", dataKey: "AC_ID" },
            { header: "Account Description", dataKey: "AC_DESC" },
            { header: "ADDRESS", dataKey: "Address" },
            { header: "Contact No", dataKey: "ContactNo" },
            { header: "Whatsapp No", dataKey: "CONTECTNO3" },
            { header: "E-Mail", dataKey: "EMAIL_ID" },
            { header: "GST No", dataKey: "IT_NO" },
            { header: "PAN No", dataKey: "GST_NO" }
        ];

        // Format data
        const rows = Array.isArray(data)
            ? data.map((item) => ({
                ...item,
                Address: [item.ADD_1, item.ADD_2, item.ADD_3, item.ADD_4, item.ADD_5, item.ADD_6, item.PINCODE]
                    .filter(Boolean)
                    .join(", "),
                ContactNo: [item.CONTECTNO1, item.CONTECTNO2]
                    .filter(Boolean)
                    .join(" / "),
            }))
            : [];

        autoTable(doc, {
            columns: columns,
            theme: "grid",
            body: rows,
            startY: 25,

            styles: {
                fontSize: 7, // 🔽 reduce font size
                cellPadding: 1.5,
            },
            margin: {
                left: 10,   // 👈 acts like startX
                right: 5,
            },

            headStyles: {
                fillColor: "#0a79c8", // teal header
                textColor: 255,
                fontSize: 8,
                halign: "center",
                fontStyle: "bold",
                // overflow: "ellipsize", // ❗ prevents breaking
                // cellWidth: "wrap",     // allow width control

            },
            columnStyles: {

                AC_DESC: { cellWidth: 35 },   // ✅ flexible
                Address: { cellWidth: 45 },
                ContactNo: { cellWidth: 25 }, // wraps nicely
                CONTECTNO3: { cellWidth: 22 },
                EMAIL_ID: { cellWidth: 20 },
                IT_NO: { cellWidth: 20 },
                GST_NO: { cellWidth: 26 },

            },

            //tableWidth: "auto",
            didParseCell: function (data) {
                // ✅ convert header text to uppercase
                if (data.section === "head") {
                    data.cell.text = data.cell.text.map(text => text.toUpperCase());
                }
            },
            didDrawPage: function (data) {
                // ===== HEADER =====
                doc.setFontSize(14);
                data.settings.margin.top = 25;
                doc.setFont("helvetica", "bold");
                doc.text(companyName, pageWidth / 2, 10, { align: "center" });

                doc.setFontSize(11);
                doc.setFont("helvetica", "normal");
                doc.text(reportName, pageWidth / 2, 16, { align: "center" });

                // line under header
                doc.setLineWidth(0.5);
                doc.line(10, 20, pageWidth - 10, 20);

                // ===== FOOTER =====
                const pageNumber = doc.internal.getNumberOfPages();

                doc.setFontSize(8);
                doc.text(
                    `Page ${pageNumber}`,
                    pageWidth - 20,
                    doc.internal.pageSize.getHeight() - 10
                );

                doc.text(
                    `Generated on: ${new Date().toLocaleDateString()}`,
                    10,
                    doc.internal.pageSize.getHeight() - 10
                );
            },
        });

        doc.save("AccountList.pdf");
    };

    if (isError) {
        return <ErrorCard />
    }

    if (isPending) {
        return <LoadingCard />
    }

    const handleConfirmBox = (data) => {
        if (data) {
            if (itemToDelete != "" & itemToDelete != null && Object.keys(itemToDelete).length > 0) {
                FndeleteAccount({
                    data: {
                        ac_id: itemToDelete.ac_id,
                        comp_code: itemToDelete.comp_code
                    }
                })
            }
            else if (itemToEdit != "" & itemToEdit != null && Object.keys(itemToEdit).length > 0) {
                {
                    dispatch(setAccountDetail(itemToEdit))
                    dispatch(setNewEntryMode(false))
                    dispatch(setAcInfo({ acId: itemToEdit.acid, isUpdate: true }))
                    navigate(linksUrl.master.account.createAccountMaster)
                }
            }
        }
        else {
            setItemToDelete("")
            setItemToEdit("")
            setPageActionType("")
        }

    }

    const columns = [
        {
            name: "Actions",
            uid: "actions",
            align: COLUMN_ALIGN_TYPE.center,
        },
        {
            name: "ACCOUNT ID",
            uid: "AC_ID",
            sortable: true,
            align: COLUMN_ALIGN_TYPE.center,
        },
        {
            name: "Description",
            uid: "AC_DESC",
            sortable: true,
            align: COLUMN_ALIGN_TYPE.center,
        },
        {
            name: "ACCOUNT Type",
            uid: "ACTYPENAME",
            sortable: true,
            align: COLUMN_ALIGN_TYPE.center,
        },
        {
            name: "UNDER GROUP",
            uid: "GRP_DESC",
            sortable: true,
            align: COLUMN_ALIGN_TYPE.center,
        },
        {
            name: "OPENING BAL",
            uid: "OPBAL",
            sortable: true,
            align: COLUMN_ALIGN_TYPE.center,
            footer: {
                type: FOOTER_TYPE.text,
                label: "Total: ",
                value: totalOpeningBal,
            },
        },

    ]

    const rowActionBtn = [
        {
            icon: <FontAwesomeIcon color="#379906" icon={faEdit} />,
            onClick: (row) => {
                setItemToDelete("")
                setPageActionType(ENUM_PAGEACTION_TYPE.Edit)
                let obj = {
                    token: token,
                    compcode: row.COMPCODE,
                    acid: row.AC_ID,
                    db_user: GetLoginCredentialDb(user, yearId)
                }
                setItemToEdit(obj)
                // dispatch(setAccountDetail(obj))
                // dispatch(setNewEntryMode(false))
                // dispatch(setAcInfo({ acId: row.AC_ID, isUpdate: true }))
                // navigate(linksUrl.master.account.createAccountMaster)
            },
            type: ROW_ACTION_BTN_TYPE.link
        },
        {
            icon: <FontAwesomeIcon color="#c40c18" icon={faTrash} />,
            onClick: (row) => {
                setItemToEdit("")
                setPageActionType(ENUM_PAGEACTION_TYPE.Delete)
                setItemToDelete({ ac_id: row.AC_ID, comp_code: row.COMPCODE })
            },
            type: ROW_ACTION_BTN_TYPE.link,
        },

    ]

    const handleAddNew = () => {

        navigate(linksUrl.master.account.createAccountMaster);
        dispatch(resetDetail())
        dispatch(resetAcInfo())
    }
    const handleImport = () => {
        navigate(linksUrl.master.account.importAccount)
    }

    return (
        <div>

            {(itemToDelete || itemToEdit) && (
                <ConfirmBox
                    handleConfirmBox={handleConfirmBox}
                    actionType={pageActionType}
                />
            )}

            <MainContainer pageName="Accounts" info={[]} breadcrumbs={["Master", "Account Master"]} >

                <div className="" style={{ textAlign: "right" }}>
                    {
                        isPending ? (<div className="flex justify-around" ><Progress
                            size="sm"
                            isIndeterminate
                            aria-label="Loading..."
                            className="max-w-md "
                        /></div>) : ""
                    }
                </div>
                <div className="flex gap-2 justify-end">
                    <Button
                        size="sm"
                        color="primary"
                        startContent={<FontAwesomeIcon icon={faPlus} />}
                        onPress={handleAddNew}
                    >
                        Add New
                    </Button>
                    {data && data.length > 0 ?
                        <Button
                            size="sm"
                            color="danger"
                            startContent={<FontAwesomeIcon icon={faDownload} />}
                            className="bg-slate-600"
                            onPress={exportAcccount}
                        >
                            Account Master List
                        </Button> : ""}
                    {/* <Button
                        size="sm"
                        color="success"
                        className="text-white"
                        startContent={<FontAwesomeIcon icon={faPlus} />}
                        onPress={handleImport}
                    >
                        Import Accounts
                    </Button> */}
                </div>

                <NextUITable
                    INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
                    data={data}
                    // handleDataChange={handleDataChange}
                    columns={columns}
                    rowActionBtn={rowActionBtn}
                    exportColumns={exportColumns}
                    downloadDataFooter={downloadDataFooter}
                    downloadFileName="account-master-List"
                    showAdvanceFilter={false}
                    id="AC_ID"
                ></NextUITable>
            </MainContainer >
        </div >
    )
}
export default AccountMaster